export const QUESTION_TYPE = {
  MCQ: 'MCQ',
  TEXTFIELD: 'TEXTFIELD',
  NPS_SCALE: 'NPS_SCALE',
  CFM_MATRIX: 'CFM_MATRIX',
  CSAT_MATRIX: 'CSAT_MATRIX',
  RATING_MATRIX: 'RATING_MATRIX',
  SLIDER_MATRIX: 'SLIDER_MATRIX',
  FILE_UPLOAD: 'FILE_UPLOAD',
  TEXT_AND_MEDIA: 'TEXT_AND_MEDIA',
  HEATMAP: 'HEATMAP',
  RANK_ORDER: 'RANK_ORDER',
} as const;

export type QuestionType = (typeof QUESTION_TYPE)[keyof typeof QUESTION_TYPE];
